export default "<p class=\"heading\">{{steps.title}}</p>\n<ul class=\"guidenceList\" *ngFor=\"let item of steps.text\">\n    <li>{{item}}</li>\n</ul>\n"